import type { Action } from '@0xtorch/core'
import { createAssetsBurnedTransfer } from './createTransfer'
import type { HandleEventParameters, HandleEventReturnType } from './types'

export const handleEthereumExecuted = ({
  chain,
  timestamp,
  source,
  events,
  relatedAddresses,
  debug,
}: HandleEventParameters): HandleEventReturnType => {
  // section: xTokens / method: TransferredAssets event が無ければ処理しない
  if (
    events.every(
      (event) =>
        event.section !== 'xTokens' || event.method !== 'TransferredAssets',
    )
  ) {
    return undefined
  }

  // section: assets / method: Burned を token transfer として処理
  const actions: Action[] = []
  for (const event of events) {
    if (event.section !== 'assets' || event.method !== 'Burned') {
      continue
    }
    const transfer = createAssetsBurnedTransfer({
      chain,
      data: event.data,
      relatedAddresses,
      debug,
    })
    if (transfer === undefined) {
      continue
    }
    actions.push({
      type: 'transfer',
      timestamp,
      source,
      order: 0,
      evidence: 'none',
      transfers: [transfer],
    })
  }

  return {
    actions,
    unhandledEvents: [],
  }
}
